import React, { useMemo } from 'react';
import { Consulta } from '../../services/mockData';
import './Consultation.css';

interface ConsultationNotificationProps {
  consultas: Consulta[];
}

export const ConsultationNotification: React.FC<ConsultationNotificationProps> = ({
  consultas,
}) => {
  const notifications = useMemo(() => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const nextWeek = new Date(today);
    nextWeek.setDate(nextWeek.getDate() + 7);

    const hoje: Consulta[] = [];
    const amanha: Consulta[] = [];
    const proximas: Consulta[] = [];

    consultas.forEach((c) => {
      const consultaDate = new Date(c.dataIso);
      const consultaDay = new Date(
        consultaDate.getFullYear(),
        consultaDate.getMonth(),
        consultaDate.getDate()
      );

      if (consultaDay.getTime() === today.getTime()) {
        hoje.push(c);
      } else if (consultaDay.getTime() === tomorrow.getTime()) {
        amanha.push(c);
      } else if (consultaDate >= now && consultaDate <= nextWeek) {
        proximas.push(c);
      }
    });

    return { hoje, amanha, proximas };
  }, [consultas]);

  const totalNotifications =
    notifications.hoje.length + notifications.amanha.length;

  if (totalNotifications === 0) {
    return null;
  }

  return (
    <div className="ns-consultation-notifications">
      {notifications.hoje.length > 0 && (
        <div className="ns-notification-item ns-notification-today">
          <span className="ns-notification-icon">📅</span>
          <div className="ns-notification-content">
            <strong>Hoje</strong>
            <span>
              {notifications.hoje.length}{' '}
              {notifications.hoje.length === 1
                ? 'consulta agendada'
                : 'consultas agendadas'}
            </span>
          </div>
        </div>
      )}

      {notifications.amanha.length > 0 && (
        <div className="ns-notification-item ns-notification-tomorrow">
          <span className="ns-notification-icon">⏰</span>
          <div className="ns-notification-content">
            <strong>Amanhã</strong>
            <span>
              {notifications.amanha.length}{' '}
              {notifications.amanha.length === 1
                ? 'consulta agendada'
                : 'consultas agendadas'}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

